/**
 * 在服务端模板转为 Canvas 图层后，按图层树恢复父组关联
 * 供完整模板与独立素材加载共用，确保选择、选框及属性面板使用相同的层级关系
 */
import type { ILayerProps } from '@meitu/saas-editor-core/es/version-types';

/**
 * 以 children 树为准补齐父组 ID，并清理根图层的过期父组 ID
 * @param layers - 当前画布的根图层列表
 * @sideEffect 原地更新图层的 parentId，不修改图层 ID 或分组结构
 */
export const restoreLayerParentIds = (layers: ILayerProps[]): void => {
    const visit = (nodes: ILayerProps[], parentId?: string) => {
        nodes.forEach((layer) => {
            layer.parentId = parentId;
            if (layer.children?.length) visit(layer.children, layer.id);
        });
    };
    visit(layers);
};
